import { useField } from 'formik';
import dayjs from 'dayjs';
import React, { CSSProperties, ReactNode, useMemo } from 'react';
import { FormItem } from 'formik-antd';
import { DatePicker } from 'antd';
// import { DatePicker } from 'formik-antd';
import { useTranslation } from 'react-i18next';

export interface DatePickerInputProp {
  label?: string | ReactNode;
  className?: string;
  formClassName?: string;
  id: string;
  name: string;
  value?: dayjs.Dayjs;
  defaultValue?: dayjs.Dayjs;
  placeholder?: string;
  format?: string;
  tooltip?: ReactNode;
  wrapperCol?: object; // ant design Col object
  labelCol?: object; // ant design Col object
  labelAlign?: 'right' | 'left';
  required?: boolean;
  allowClear?: boolean;
  disabled?: boolean;
  picker?: 'date' | 'week' | 'month' | 'quarter' | 'year';
  inputReadOnly?: boolean;
  showTime?: object | boolean;
  onChange?: (value: dayjs.Dayjs | null, dateString: string | string[]) => void;
  disabledDate?: (currentDate: dayjs.Dayjs) => boolean;
  disabledTime?: any;
  style?: CSSProperties;
  validateStatus?: '' | 'success' | 'warning' | 'error' | 'validating';
  showToday?: boolean;
  help?: string;
}

export const DatePickerInput: React.FC<DatePickerInputProp> = ({
  className,
  formClassName,
  label,
  name,
  tooltip,
  labelCol,
  wrapperCol,
  labelAlign,
  required,
  onChange,
  value,
  defaultValue,
  id,
  placeholder,
  disabledDate,
  disabledTime,
  style,
  showTime,
  picker,
  format,
  disabled,
  inputReadOnly,
  allowClear,
  validateStatus,
  showToday,
  help,
}) => {
  const { t } = useTranslation();
  const [field, meta] = useField({ name });

  const displayValidateStatus = useMemo(() => {
    if (meta.touched && meta.error) return 'error';

    return validateStatus;
  }, [meta.error, meta.touched, validateStatus]);

  return (
    <FormItem
      className={formClassName}
      label={label}
      name={field.name}
      tooltip={tooltip}
      labelCol={labelCol}
      wrapperCol={wrapperCol}
      labelAlign={labelAlign}
      validateStatus={displayValidateStatus}
      required={required}
      help={help || (meta.touched && meta.error ? t(`${meta.error}`) : undefined)}
    >
      <div>
        <DatePicker
          className={className}
          onChange={onChange}
          value={value || null}
          defaultValue={defaultValue}
          id={id}
          placeholder={placeholder}
          disabledDate={disabledDate}
          disabledTime={disabledTime}
          style={style}
          showTime={showTime}
          format={format}
          disabled={disabled}
          inputReadOnly={inputReadOnly}
          picker={picker}
          allowClear={allowClear}
          showToday={showToday}
        />
      </div>
    </FormItem>
  );
};

DatePickerInput.defaultProps = {
  allowClear: true,
  labelAlign: 'left',
  style: { width: '100%' },
};
